<template>
<v-app>
  <v-expansion-panels>
    <v-expansion-panel
      v-for="(item,i) in content"
      :key="i"
    >
      <v-expansion-panel-header>
        <span class="h3 mb-0">{{ item.title }}</span>
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <div v-if="item.acf_fc_layout == 'text'" v-html="item.content"></div>
        <div v-else-if="item.acf_fc_layout == 'mitglied'">
          <div class="wp-block-columns">
            <div class="wp-block-column">
              <img :src="item.image.sizes.large"
                   :alt="item.title"
                   class="img-fluid" />
            </div>

            <div class="wp-block-column">
              <p class="text-small">
                <i class="fas fa-map-marker-alt fa-fw text-primary"></i>
                {{ item.street }}<br />
                <i class="far fa-fw"></i>
                {{ item.zip }}
              </p>
            </div>

            <div class="wp-block-column">
              <p class="text-small mb-0">
                <i class="fas fa-phone fa-fw text-primary"></i>
                <a :href="'tel:' + getPhoneNumber(item.phone)"
                   title="Rufen Sie uns an"
                   class="text-normal">
                    {{ item.phone }}
                </a>
              </p>

              <p class="text-small">
                <i class="fas fa-globe fa-fw text-primary"></i>
                <a :href="item.homepage"
                   title="zur Homepage"
                   target="_blank"
                   class="text-normal">
                    Zur Homepage
                </a>
              </p>
            </div>

            <div class="wp-block-column">
              <a :href="'mailto:' + item.email"
                  title="Senden Sie uns eine Nachricht"
                  class="text-normal">
                  <i class="fas fa-envelope"></i>
              </a>
            </div>
          </div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</v-app>
</template>

<script>
export default {
  name: "Accordion",

  computed: {
    content() {
      return this.$root.content;
    }
  },

  methods: {
    getPhoneNumber(val) {
      let phone = val;
      phone = phone.replace(/ /g, "").replace("(0)", "").replace("(", "").replace(")", "").replace(/\//g, "");

      if (phone.charAt(0) === "0") {
        phone = '+49' + phone.substring(1);
      }

      return phone;
    }
  }
}
</script>
